<router-outlet></router-outlet>
<p class="version">v3.0</p>